import { cn } from "@/lib/utils";

export function LocateIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-6.5 w-[25px] text-dark-raspberry", className)}
      fill="none"
      viewBox="0 0 25 26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12.185"
        cy="12.31"
        r="8.185"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="12.185"
        cy="12.31"
        fill="currentColor"
        r="3.088"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.185 3.269l.001-2.144m-.002 22.049l.001-2.143m9.022-8.721h2.144M1 12.31l2.144.002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
